var _style, _rect, _defs, _path, _path2, _path3, _path4, _path5, _feColorMatrix, _feBlend, _mask, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470 150",
    style: {
      enableBackground: "new 0 0 470 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#2E3440;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{clip-path:url(#SVGID_2_);mask:url(#SVGID_3_);fill:#317DFB;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -175,
    className: "st0",
    width: 670,
    height: 500
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -100,
    y: -175,
    width: 670,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,38.8h-5.5c-8.1,0-10.6,2.5-10.6,11.1v3.9h12.8v11.6L65,66.2v44.4l9.8,0.6v11.6H38.6v-11.6l9.8-0.6V66 l-9.8-0.6V53.8h9.8v-4c0-16.9,5.8-23.7,22.7-23.7c3.5,0,6.8,0.3,10.1,0.9V38.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.8,55.5c-2.7,1.6-5.8,4.6-9.3,9.4V53.8H81.1v11.6l9.8,0.7v44.5l-9.8,0.6v11.6h36.2v-11.6l-9.8-0.6V73.8 c3.7-2.4,6.8-4,9.3-4.6c1.2-0.4,2.5-0.6,4.1-0.8c0.5-7,2.4-11.9,6-15c0.1-0.1,0.2-0.2,0.3-0.3C123,53,119.5,53.8,116.8,55.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242,56.4c4.3,3.1,4.9,7.1,4.9,16.3l-16.1,1c0-3.9-0.8-6.3-2.2-7.5c-1.4-1.2-4.9-1.7-10.2-1.7 c-5.5,0-9.2,0.5-10.7,1.4c-1.4,0.9-2.2,2.7-2.2,5.4c0.5,6.6,1.2,7.4,19.1,10.8c11.2,1.9,16,3.1,19.5,6.3c3.6,3.2,4,6.7,4,14.8 c0,6.2-0.6,10.7-2.1,13.4c-1.4,2.7-4.1,4.5-8.1,5.7c-4,1-10.6,1.5-19.7,1.5c-9,0-15.6-0.5-19.6-1.7c-4-1.2-6.6-3.1-8-5.8 c-1.4-2.8-2.1-7.5-2.1-13.9l16.1-1c0,4.5,0.8,7.4,2.3,8.6c1.7,1.2,5.4,1.8,11.2,1.8c5.9,0,9.7-0.5,11.4-1.4c1.7-1,2.6-3.1,2.6-6.2 c0-3.4-0.8-5.7-2.5-7c-1.7-1.3-5.8-2.6-12.6-3.7c-13.3-2.6-19-3.9-23.1-7.4c-4-3.6-4.4-6.8-4.4-14.7c0-5.4,0.6-9.3,1.8-11.7 c2.6-5,9.7-7.2,27.1-7.2C231.7,52.6,237.8,53.1,242,56.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.5,65.4V53.8h-18.2V38.6h-16.6v15.2H246c3.6,3.1,4.8,7,5.2,12l4.5,0.3v41.7c0,11.2,5,15.7,19.1,15.7 c6.7,0,12-0.8,15.7-2.4v-10.1h-10.8c-5.5,0-7.3-1.7-7.3-6.7V66.4L290.5,65.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.2,58.8c-3.7-5-8.3-6.2-17-6.2c-5.9,0-10.7,0.8-14.2,2.2c-3.5,1.4-7.2,4.1-11.1,8.1V26.1h-26.4v11.7 l9.8,0.5v84.5h16.6V115c3.5,3.5,6.8,5.9,10.1,7.1c3.2,1.2,7.5,1.8,13,1.8c9.4,0,14.7-1.4,18.8-6.7c4.1-5.3,5.5-14.1,5.5-29 C359.3,72.7,358.2,63.8,354.2,58.8 M328.9,110.3c-6.7,0-12.4-1.4-17-4.1V70.8c5.8-3.6,9.4-4.6,17.3-4.6c5.8,0,9.7,1.3,11.5,4 c1.8,2.7,2.7,8.6,2.7,18.1C342.7,108.2,341.3,109.8,328.9,110.3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 346,
    y: 32.5,
    width: 51.4,
    height: 90.3
  }, _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })), /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "source",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 32.5,
    width: 51.4,
    height: 90.3,
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.8,
    y: 34,
    transform: "matrix(0.9889 -0.1483 0.1483 0.9889 -2.4782 51.8391)",
    className: "st1",
    width: 15,
    height: 17
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.9,109.9c-1,4.2-2.5,7.5-4.6,10.1c-0.8,1.1-1.7,2-2.6,2.8h42.7c-2.9-2.7-4.9-6.8-5.3-12.9l-6.5-0.3V32.5 h-7.5l-0.1,0.1l-32,4.9l1.8,11.7l0.1,0.9l1.9-0.2l18.3-2.3v62L361.9,109.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.1,66.4v37.8c0,5,1.8,6.7,7.4,6.7h10.8V121c-3.7,1.7-9,2.5-15.7,2.5c-14.1,0-19.1-4.5-19.1-15.7V38.6h16.6 v15.2h18.3v11.6L413.1,66.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.8,52.6c6.2,0,11,0.4,14.4,1.3c7,1.7,11.6,7.4,12.9,16.1c0.7,4.3,1,10.3,1,18.2c0,7.9-0.3,13.9-1,18.3 c-1.4,8.6-6,14.4-12.9,16.1c-3.4,0.9-8.2,1.3-14.4,1.3s-11-0.4-14.5-1.3c-6.9-1.7-11.3-7.5-12.7-16.1c-0.7-4.4-1-10.4-1-18.3 c0-7.9,0.3-13.9,1-18.2c1.4-8.8,5.8-14.4,12.7-16.1C141.8,53,146.6,52.6,152.8,52.6 M141.2,69.5c-2.2,3.5-2.4,8-2.4,18.7 c0,8.6,0.3,12.9,1.3,16.6c2.1,5.3,5.2,5.8,12.7,6.1c6.2,0,10.1-1.3,11.7-3.9c1.6-2.6,2.4-8.9,2.4-18.8c0-9.9-0.8-16.3-2.4-18.7 c-1.6-2.6-5.5-3.9-11.7-3.9C146.3,65.6,143.5,66,141.2,69.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb97a8fc8167b9575249bb6c632470f0.svg";
export { ForwardRef as ReactComponent };